import { InvestmentEntityTabActivity } from "features/investments/InvestmentEntityTabActivity";
import { InvestmentSetupTabProps } from "features/investments/setup/InvestmentSetupTabProps";
import { useOutletContext } from "react-router-dom";

export const InvestmentTabActivity: React.FC = () => {
  const { investmentId, fundFamilyId } =
    useOutletContext<InvestmentSetupTabProps>();

  return (
    <InvestmentEntityTabActivity
      fundFamilyId={fundFamilyId}
      investmentEntityIds={[investmentId]}
    />
  );
};
